import type { ReactNode } from "react";
import React from "react";

const fr = {
  "404.action": "Retourner à la page d'accueil",
  "404.description": "L'URL a peut-être changé depuis que vous l'avez utilisée",
  "404.title": (url: string) => (
    <>
      <strong>{url}</strong> introuvable :(
    </>
  ),
  "badge.beta": "Beta",
  "badge.beta.description":
    "Fonctionnalité accessible en accès anticipé, encore en cours de développement et pouvant présenter des limitations",
  "badge.in_development": "En développement",
  "chart.download.error": "Une erreur est survenue lors du téléchargement en .png",
  "chart.download.png": "Télécharger en .png",
  "chart.download.success": (filename: string) => `Le fichier ${filename} a été exporté`,
  "chart.full_viewport.close": "Quitter le mode plein écran",
  "chart.full_viewport.open": "Ouvrir en plein écran",
  "charts.info_tooltip.more": "En savoir plus",
  "color_picker.default": "Couleur par défaut",
  "color_picker.palette": "Couleur personnalisée",
  "daterangepicker.apply": "Appliquer",
  "daterangepicker.cancel": "Annuler",
  "daterangepicker.end_time": "Heure de fin",
  "daterangepicker.error.dates_unavailable": "les dates sélectionnées ne sont pas disponibles",
  "daterangepicker.error.startdate_superior_to_enddate":
    "La date de début est supérieure à la date de fin",
  "daterangepicker.instruction": "↲ entrée pour appliquer",
  "daterangepicker.start_time": "Heure de début",
  "daterangepicker.tooltip.apply": "Appliquer",
  "daterangepicker.tooltip.clear": "Effacer",
  "daterangepicker.tooltip.open_calendar": "Ouvrir le calendrier",
  "detail.summary": "Détails",
  "details.open.hint": "Cliquer pour étendre la zone",
  "drawer.cancel": "Annuler",
  "drawer.confirm": "Valider",
  "dropzone.drop_here": ({ oneFile }: { oneFile: boolean }): string =>
    oneFile ? "Glissez votre fichier ici ou" : "Glissez vos fichiers ici ou",
  "dropzone.select_files": ({ oneFile }: { oneFile: boolean }): string =>
    oneFile ? "Sélectionnez votre fichier" : "Sélectionnez vos fichiers",
  "dropzoneV2.accepted_files.separator.or": "ou",
  "dropzoneV2.expected_file_format": "Format de fichier attendu :",
  "dropzoneV2.file_version_detected": `Version de fichier détectée :`,
  "dropzoneV2.loading": "Fichier en cours de traitement",
  "dropzoneV2.max_size": (maxSize: number) => `(Taille maximum : ${maxSize} Mo)`,
  "dropzoneV2.max_size_file.text": (maxSizeInMo: number) =>
    `La taille du fichier dépasse la limite autorisée de ${maxSizeInMo} Mo.`,
  "dropzoneV2.message.no_error_message_defined": "Aucun message d'erreur défini",
  "dropzoneV2.no_valid_file.text": ({ nameFile }: { nameFile: ReactNode }) => (
    <>
      Le fichier {nameFile} <br /> n&apos;est pas valide pour l&apos;import.
    </>
  ),
  "dropzoneV2.no_valid_files.text": (n: number) => (
    <>
      Certains fichiers parmi les {n} ajoutés <br />
      ne sont pas valides pour l&apos;import.
    </>
  ),
  "dropzoneV2.rejectedFiles.message": ({ name, accept }: { name: string; accept: string }) =>
    `Le format du fichier ${name} n’est pas valide. Veuillez importer un fichier de type ${accept}.`,
  "dropzoneV2.sample_File": `Fichier d'exemple`,
  "dropzoneV2.select_files": ({ oneFile }: { oneFile: boolean }): string =>
    oneFile ? "Sélectionnez-le sur votre ordinateur" : "Sélectionnez vos fichiers",
  "dropzoneV2.tooltip.download_error_message": "Télécharger le message d'erreur détaillé",
  "dropzoneV2.valid.select_files": ({ oneFile }: { oneFile: boolean }): string =>
    oneFile
      ? "Sélectionnez ou glissez un nouveau fichier"
      : "Sélectionnez ou glissez de nouveaux fichiers",
  "dropzoneV2.valid_file.missing_info.text": ({ nameFile }: { nameFile: ReactNode }) => (
    <>Le fichier {nameFile} est valide, mais certaines informations nécessaires sont manquantes.</>
  ),
  "dropzoneV2.valid_file.text": ({ nameFile }: { nameFile: ReactNode }) => (
    <>
      Le fichier {nameFile} <br /> est valide pour l&apos;import.
    </>
  ),
  "dropzoneV2.valid_files.missing_info.text": (n: number) => (
    <>Les {n} fichiers sont valides, mais certaines informations nécessaires sont manquantes.</>
  ),
  "dropzoneV2.valid_files.text": (n: number) => `Les ${n} fichiers sont valides pour l'import.`,
  "filter.none": "Aucun",
  "filter.reset": "Réinitialiser",
  "filter.title": (title: string) => `${title} :\u00A0`,
  filters: "Filtres",
  "group.no_group": "Aucun",
  "highcharts.tooltip.flag.description": ({
    name,
    description,
  }: {
    name: string;
    description: string;
  }) => `${name} : ${description}`,
  "image_reader.reset": "Réinitialiser le zoom et la position",
  "image_reader.zoom_in": "Zoomer",
  "image_reader.zoom_out": "Dézoomer",
  "input.mandatory": "Obligatoire",
  "input.revert": "Réinitialiser",
  "markdown.table.modal.form.input.error.columns": "Le nombre de colonnes ne peut pas être vide.",
  "markdown.table.modal.form.input.error.max_columns":
    "Le nombre de colonnes ne peut être supérieur à 20",
  "markdown.table.modal.form.input.error.max_rows":
    "Le nombre de lignes ne peut être supérieur à 20",
  "markdown.table.modal.form.input.error.rows": "Le nombre de lignes ne peut pas être vide.",
  "markdown_editor.modal.insert": "Insérer",
  "markdown_editor.modal.link.label": "Lien",
  "markdown_editor.modal.link.placeholder": "Entrez l'URL (commençant par https://)",
  "markdown_editor.plugin.equation.edit_hint": "Double-cliquez pour éditer l’équation",
  "markdown_editor.plugin.equation.input_label": "Équation (en LaTeX)",
  "markdown_editor.plugin.equation.insert": "Insérer une équation",
  "markdown_editor.plugin.equation.insert.disable": "Équation non disponible au sein des tableaux",
  "markdown_editor.plugin.equation.insert_short": "Insérer",
  "markdown_editor.plugin.equation.preview_label": "Prévisualisation",
  "markdown_editor.plugin.equation.preview_label.empty": "Aucune équation à visualiser",
  "markdown_editor.plugin.equation.tooltip.text.description":
    "Des exemples de syntaxe LaTeX sont disponibles dans le guide utilisateur.",
  "markdown_editor.plugin.equation.tooltip.text.link": "Lien vers la section dédiée",
  "markdown_editor.table.modal.form.input.label.columns": "Nombre de colonnes",
  "markdown_editor.table.modal.form.input.label.rows": "Nombre de lignes",
  "markdown_editor.table.modal.form.ok_button_name": "Insérer",
  "markdown_editor.table.modal.title": "Insérer un tableau",
  "markdown_editor.table.toolbar.button": "Insérer un tableau",
  "markdown_editor.table.toolbar.button.disable": "Tableau non disponible au sein des tableaux",
  "markdown_editor.tool_bar.link.error.invalid_url": "URL invalide",
  "markdown_editor.tool_bar.link.insert": "Insérer un lien",
  "markdown_editor.tool_bar.link.remove": "Supprimer le lien",
  "markdown_editor.tool_bar.link.replace": "Remplacer le lien",
  "markdown_editor.tool_bar.tooltip.bold": "Gras",
  "markdown_editor.tool_bar.tooltip.italic": "Italique",
  "markdown_editor.tool_bar.tooltip.table.disable": "Formatage non disponible au sein des tableaux",
  "message_card.answer": "Répondre",
  "message_card.answers": ({ count }: { count: number }) =>
    count === 1 ? `${count} réponse` : `${count} réponses`,
  "message_card.ask_delete": "Supprimer ?",
  "message_card.ask_delete_thread": "Supprimer la conversation ?",
  "message_card.cancel": "Annuler",
  "message_card.confirm_delete": "Supprimer",
  "message_card.delete": "Supprimer",
  "message_card.delete_thread": "Supprimer la conversation",
  "message_card.edit": "Modifier",
  "message_editor.cancel": "Annuler",
  "message_editor.publish": "Publier",
  "modal.cancel": "Annuler",
  "modal.confirm": "Valider",
  "placeholder.search": "Rechercher",
  "project.dashboard.block.comment_rich_text.error.text_too_long":
    "Le texte ne doit pas dépasser 4000 caractères",
  "react_select.confirm_delete": (label: string) => `Supprimer "${label}" ?`,
  "react_select.confirm_edit": (label: string) => `Changer le label "${label}" partout ?`,
  "react_select.create": (str: string) => `Créer "${str}"`,
  "react_select.no_result": "Pas de résultat",
  "react_select.no_value": "Aucune valeur",
  "rollback.title": "Revenir à la valeur précédente",
  search: "Rechercher",
  "select.no_result": "Aucun",
  "selectlist.no_data": "Aucune donnée",
  "selectlist.selected_count": ({ count }: { count: number }) =>
    count < 2 ? `${count} élément sélectionné` : `${count} éléments sélectionnés`,
  "side_panel.close": "Fermer le panneau",
  "side_panel.open": "Ouvrir le panneau",
  "table.columns": "Choix des colonnes",
  "table.display": "Affichage",
  "table.double_click_to_edit": "Double-cliquer pour éditer",
  "table.empty": "Pas de données",
  "table.form.cancel": "Annuler",
  "table.form.confirm": "Confirmer",
  "table.groupby": "Grouper par",
  "table.groupby.none": "Aucun",
  "table.pagination.elementByPage": "Éléments par page",
  "table.pagination.of": "sur",
  "table.select_all": "Tout sélectionner",
  "table.unselect_all": "Tout déselectionner",
  "textarea.maxLength.exceeded": "(la limite maximale a été dépassée)",
  "textarea.maxLength.label": "caractères",
  "time_period.days": ({
    days,
    hours,
    minutes,
  }: {
    days: number;
    hours: number;
    minutes: number;
  }) => {
    const daysSection = days > 0 ? `${days} j` : "";
    const hoursSection = hours > 0 || days !== 0 ? `${hours} h` : "";
    return `${daysSection} ${hoursSection} ${minutes} min`;
  },
};

export default fr;
